import fetch from 'cross-fetch';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

// Function to parse the URL
function btoa(input) {
  if (input === void 0) {
    input = '';
  }

  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  var str = input;
  var output = ''; // eslint-disable-next-line

  for (var block = 0, charCode, i = 0, map = chars; str.charAt(i | 0) || (map = '=', i % 1); // eslint-disable-line no-bitwise
  output += map.charAt(63 & block >> 8 - i % 1 * 8) // eslint-disable-line no-bitwise
  ) {
    charCode = str.charCodeAt(i += 3 / 4);

    if (charCode > 0xff) {
      throw new Error('"btoa" failed: The string to be encoded contains characters outside of the Latin1 range.');
    }

    block = block << 8 | charCode; // eslint-disable-line no-bitwise
  }

  return output;
}

function validateIndex(index) {
  if (!index) {
    throw new Error('appbase-analytics: A valid index must be present to record analytics events.');
  }
}
function validateCredentials(credentials) {
  if (!credentials) {
    throw new Error('appbase-analytics: Auth credentials is missing.');
  }
}
function validateURL(url) {
  if (!url) {
    throw new Error('appbase-analytics: URL is missing.');
  }
}
function validateQuery(query, queryID) {
  if ((query === undefined || query === null) && !queryID) {
    throw new Error('appbase-analytics: query or queryID must be present to register a click/conversion event');
  }
}
function validateQueryID(queryID) {
  if (!queryID) {
    throw new Error('appbase-analytics: queryID must be present to save search/favorite');
  }
}
function validateClickObjects(objects) {
  if (!objects || Object.keys(objects).length < 1) {
    throw new Error('appbase-analytics: at least one click object must be present to register a click event');
  }
}
function validateConversionObjects(objects) {
  if (!objects || Object.keys(objects).length < 1) {
    throw new Error('appbase-analytics: at least one click object must be present to register a click event');
  }
}

function initClient(config) {
  if (config === void 0) {
    config = {};
  }

  var metrics = {
    credentials: config.credentials,
    index: config.index,
    url: config.url,
    userID: config.userID,
    globalCustomEvents: config.globalCustomEvents,
    queryID: '',
    headers: null,
    _request: function _request(method, url, body, queryParams, callback) {
      var finalBody = _extends({
        user_id: metrics.userID
      }, body, {
        custom_events: _extends({}, body && body.custom_events, {}, metrics.globalCustomEvents)
      });

      var queryParamsString = '';

      if (queryParams) {
        queryParamsString = Object.keys(queryParams).map(function (param) {
          return param + "=" + queryParams[param];
        }).join('&');
      }

      return fetch(metrics.url + "/" + url + "?" + queryParamsString, {
        method: method,
        headers: _extends({}, metrics.headers, {
          'Content-Type': 'application/json',
          Authorization: "Basic " + btoa(metrics.credentials)
        }),
        body: method === 'GET' ? null : JSON.stringify(finalBody)
      }).then(function (response) {
        if (callback) {
          callback(null, response);
        }
      })["catch"](function (err) {
        if (callback) {
          callback(err, null);
        }
      });
    }
  };
  validateIndex(metrics.index);
  validateCredentials(metrics.credentials);
  validateURL(metrics.url); // To register a search

  metrics.search = function (searchConfig, callback) {
    validateQuery(searchConfig.query, searchConfig.queryID);

    var captureQueryID = function captureQueryID(err, res) {
      if (res) {
        res.json().then(function (response) {
          if (response && response.query_id) {
            metrics.queryID = response.query_id;
          }

          if (callback) {
            callback(err, res);
          }
        })["catch"](function (err2) {
          if (callback) {
            callback(err2, res);
          }
        });
      } else if (callback) {
        callback(err, res);
      }
    }; // just to avoid the flow type error


    if (metrics._request) {
      var requestBody = {
        query: searchConfig.query,
        query_id: searchConfig.queryID,
        custom_events: searchConfig.customEvents,
        filters: searchConfig.filters,
        hits: searchConfig.hits,
        impressions: searchConfig.impressions
      };

      metrics._request('PUT', metrics.index + "/_analytics/search", requestBody, null, captureQueryID);
    }
  }; // To register a click


  metrics.click = function (clickConfig, callback) {
    validateQuery(clickConfig.query, clickConfig.queryID);
    validateClickObjects(clickConfig.objects); // just to avoid the flow type error

    if (metrics._request) {
      var requestBody = {
        click_on: clickConfig.objects,
        click_type: clickConfig.isSuggestionClick ? 'suggestion' : 'result',
        query: clickConfig.query,
        query_id: clickConfig.queryID,
        custom_events: clickConfig.customEvents,
        meta: clickConfig.meta
      };

      metrics._request('PUT', metrics.index + "/_analytics/click", requestBody, null, callback);
    }
  }; // To register a conversion


  metrics.conversion = function (conversionConfig, callback) {
    validateQuery(null, conversionConfig.queryID);
    validateConversionObjects(conversionConfig.objects); // just to avoid the flow type error

    if (metrics._request) {
      var requestBody = {
        conversion_on: conversionConfig.objects,
        query_id: conversionConfig.queryID,
        meta: conversionConfig.meta
      };

      metrics._request('PUT', metrics.index + "/_analytics/conversion", requestBody, null, callback);
    }
  }; // To save search


  metrics.saveSearch = function (saveSearchConfig, callback) {
    validateQueryID(saveSearchConfig.queryID);
    var requestBody = {
      query_id: saveSearchConfig.queryID,
      save_search_id: saveSearchConfig.saveSearchID,
      save_search_meta: saveSearchConfig.saveSearchMeta,
      user_id: saveSearchConfig.userID,
      custom_events: saveSearchConfig.customEvents
    };

    metrics._request('PUT', '_analytics/save-search', requestBody, null, callback);
  }; // To delete save search


  metrics.deleteSavedSearch = function (saveSearchId, callback) {
    metrics._request('DELETE', '_analytics/save-search/' + saveSearchId, null, null, callback);
  }; // To retrieve saved searches


  metrics.getSavedSearches = function (filters, callback) {
    // just to avoid the flow type error
    if (metrics._request) {
      metrics._request('GET', '_analytics/saved-searches', null, filters, callback);
    }
  }; // To record a favorite document


  metrics.favorite = function (favoriteConfig, callback) {
    validateQueryID(favoriteConfig.queryID);

    if (!favoriteConfig.favoriteOn || favoriteConfig.favoriteOn === '') {
      throw new Error('appbase-analytics: favoriteOn property is required');
    }

    if (!favoriteConfig.source) {
      throw new Error('appbase-analytics: source property is required');
    }

    var requestBody = {
      query_id: favoriteConfig.queryID,
      favorite_on: favoriteConfig.favoriteOn,
      source: favoriteConfig.source,
      id: favoriteConfig.id,
      meta: favoriteConfig.meta,
      user_id: favoriteConfig.userID,
      custom_events: favoriteConfig.customEvents
    };

    metrics._request('PUT', '_analytics/favorite', requestBody, null, callback);
  }; // To retrieve favorites


  metrics.getFavorites = function (filters, callback) {
    // just to avoid the flow type error
    if (metrics._request) {
      metrics._request('GET', '_analytics/favorites', null, filters, callback);
    }
  }; // Sets the userID


  metrics.setUserID = function (userID) {
    metrics.userID = userID;
  }; // Sets the global events


  metrics.setGlobalCustomEvents = function (globalEvents) {
    metrics.globalCustomEvents = globalEvents;
  }; // Sets the headers


  metrics.setHeaders = function (headers) {
    metrics.headers = headers;
  }; // get queryID


  metrics.getQueryID = function () {
    return metrics.queryID;
  };

  return metrics;
}

var index = {
  init: initClient
};

export default index;
